// Mock data for TAG Technical Staffing Website

export const testimonials = [
  {
    id: 1,
    name: "Manuel Sojer, PhD",
    position: "Executive Leadership",
    company: "Maschinenfabrik Reinhausen, GmbH",
    content: ". . .  supported me in recruiting both in the U.S. and Europe and his ability to source and assess candidates on both sides of the Atlantic has been impressive.  . . . understands the respective industry and technical domain specifics.  . . . to build very convincing pipelines of candidates.   . . .  significantly contributed to the commercial success of my business - I would recommend without hesitation.",
    rating: 5,
    industry: "AI/ML"
  },
  {
    id: 2,
    name: "Kevin Speer",
    position: "Technology Director, SiC Power Solutions",
    company: "Multinational Semiconductor Manufacturer",
    content: ". . . helped find the exceedingly rare talent and skillsets the emerging <em>wide-band-gap semiconductor</em> market requires... placed roles across the value chain; from deeply technical materials and device scientists, to applications engineers, product marketing and business development . . . HIGHLY RECOMMEND!",
    rating: 5,
    industry: "Semiconductors"
  },
  {
    id: 3,
    name: "Naimish Patel",
    position: "Chief Executive Officer",
    company: "Gridco Systems, Inc.",
    content: ". . . engaged to grow the executive team...he not only brought forth a highly compelling set of candidates, but most importantly was honest... never just trying to fill a position in the shortest time.  ... For those looking to grow their teams for the long term with candidates that meet not just the technical requirements, but are also culturally well-matched.   . . . would recommend without hesitation.",
    rating: 5,
    industry: "Future Grid"
  },
  {
    id: 4,
    name: "Gary Earle",
    position: "Director of Executive Talent Acquisition",
    company: "$151 Billion Multinational",
    content: ". . . without a doubt, one of the <em>top engineering recruitment specialists in the country</em>... can communicate with engineering and engineering managers at their technical level... able to quickly bring forth top passive candidates for all professional levels.",
    rating: 5,
    industry: "Power Electronics"
  },
  {
    id: 5,
    name: "Phil Charatz",
    position: "President, Americas",
    company: "Fuji Electric Corporation of America",
    content: ". . . an excellent resource and supported our requirements to the fullest . . .  recommend to anyone looking to fill a position in the power industry.",
    rating: 5,
    industry: "Power Electronics"
  },
  {
    id: 6,
    name: "George Kirby, P.E.",
    position: "Director of Sales",
    company: "American Superconductor",
    content: "Christian's firm was challenged with helping me expand my team rapidly to meet market demand. They managed the task quite effectively by building out a robust pipeline of candidates, and always managing contingencies in the event that particular candidates fell through.  Overall he was successful in achieving our mutual goals and for that I am grateful. I would recommend Christian and his firm to friends and colleagues.",
    rating: 5,
    industry: "Semiconductors"
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Executive Search: VP of AI Engineering",
    industry: "AI/ML",
    challenge: "Fortune 500 company needed a VP to lead 200+ person AI division working on transformer architectures and large-scale model deployment",
    solution: "TAG's technical recruiters evaluated candidates on advanced ML theory, infrastructure scaling, and leadership capabilities",
    outcome: "Placed PhD with 15+ years experience leading teams at major tech firms. Successfully scaled the division by 40% in first year",
    timeframe: "45 days"
  },
  {
    id: 2,
    title: "Rapid Team Build: Semiconductor Design Engineers",
    industry: "Semiconductors",
    challenge: "Startup needed to hire 12 ASIC design engineers with expertise in 5nm and below process nodes within 90 days",
    solution: "Leveraged TAG's network of senior semiconductor professionals and deep technical vetting process",
    outcome: "Placed 12 engineers in 75 days, all with direct experience in advanced node design at tier-1 foundries",
    timeframe: "75 days"
  },
  {
    id: 3,
    title: "CTO Placement: Power Electronics Innovator",
    industry: "Power Electronics",
    challenge: "Electric vehicle charging infrastructure company needed CTO with expertise in wide-bandgap semiconductors and grid integration",
    solution: "TAG identified candidates from adjacent industries with transferable skills and deep technical foundations",
    outcome: "Placed CTO who led the development of next-gen 350kW charging systems, resulting in $50M Series B funding",
    timeframe: "60 days"
  }
];

export const expertiseAreas = [
  {
    id: "semiconductors",
    title: "Semiconductors",
    icon: "Chip",
    description: "From advanced process nodes to heterogeneous integration",
    specializations: [
      "SiC & GaN Power Device Design",
      "Advanced Node Processes (3nm, 2nm, beyond)",
      "Memory Architecture (DRAM, NAND, Emerging)",
      "Analog/Mixed-Signal IC Design",
      "EDA Tool Development",
      "Process & Device Engineering",
      "Packaging & 3D Integration",
      "Yield Analysis & Optimization"
    ],
    bgColor: "from-cyan-900/20 to-blue-900/20"
  },
  {
    id: "aiml",
    title: "AI & Machine Learning",
    icon: "Brain",
    description: "Deep learning architectures to production ML systems",
    specializations: [
      "Large Language Models & Transformers",
      "Computer Vision & Image Processing",
      "ML Infrastructure & MLOps",
      "Neural Architecture Search",
      "Reinforcement Learning Systems",
      "Edge AI & Model Optimization",
      "AI Hardware Acceleration",
      "Responsible AI & Ethics"
    ],
    bgColor: "from-teal-900/20 to-cyan-900/20"
  },
  {
    id: "power",
    title: "Power Electronics",
    icon: "Zap",
    description: "Wide-bandgap devices to grid-scale power conversion",
    specializations: [
      "Data Center Power Supply",
      "Inverter & Converter Design",
      "Power System Modeling",
      "Electric Vehicle Charging",
      "Motor Drive Systems",
      "Digital Power Control",
      "Advanced Robotics",
      "High-Frequency Magnetics"
    ],
    bgColor: "from-blue-900/20 to-teal-900/20"
  },
  {
    id: "grid",
    title: "Future Grid & Energy",
    icon: "Network",
    description: "Smart grids to renewable energy integration",
    specializations: [
      "Hyperscale Data Center Solutions",
      "Grid Modernization & Smart Grid",
      "Energy Storage Systems",
      "Microgrid & Distributed Energy",
      "Grid-Scale BESS Design",
      "Power System Protection",
      "Energy Management Software",
      "Grid Analytics & Forecasting"
    ],
    bgColor: "from-cyan-900/20 to-teal-900/20"
  }
];

export const services = [
  {
    id: 1,
    title: "Direct Hire",
    icon: "UserCheck",
    description: "Permanent placement of engineering talent across all technical disciplines",
    features: [
      "Comprehensive technical screening by expert engineers",
      "Culture fit assessment",
      "Competitive compensation benchmarking",
      "Reference verification and background checks",
      "90-day placement guarantee"
    ]
  },
  {
    id: 2,
    title: "Expert Design Consultants",
    icon: "Clock",
    description: "Expert design professionals across semiconductors, power electronics, AI/ML, and grid systems",
    features: [
      "Data center power architecture",
      "Power conversion and motor drive design",
      "System architecture review",
      "Solid state devices",
      "Embedded systems and RF design"
    ]
  },
  {
    id: 3,
    title: "Executive Search",
    icon: "TrendingUp",
    description: "Strategic placement of engineering leaders and technical executives",
    features: [
      "C-suite and VP-level placement",
      "Confidential search capabilities",
      "Comprehensive leadership assessment",
      "Market intelligence and insights",
      "Succession planning support"
    ]
  },
  {
    id: 4,
    title: "Strategic Hiring Consultants",
    icon: "FileCheck",
    description: "Expert guidance on technical hiring strategies and team building",
    features: [
      "Technical hiring process optimization",
      "Compensation strategy development",
      "Technical assessment design",
      "Employer branding for engineering",
      "Talent pipeline development"
    ]
  }
];

export const stats = [
  {
    label: "Average Years Engineering Experience",
    value: "15+",
    icon: "Award"
  },
  {
    label: "Technical Placements",
    value: "2,500+",
    icon: "Users"
  },
  {
    label: "Client Satisfaction Rate",
    value: "98%",
    icon: "ThumbsUp"
  },
  {
    label: "Average Time to Placement",
    value: "21 Days",
    icon: "Clock"
  }
];

export const differentiators = [
  {
    id: 1,
    title: "Technologists First",
    icon: "GraduationCap",
    description: "Every recruiter on our team is a seasoned engineer or scientist with 10-20+ years of hands-on technical experience. We've designed chips, built ML models, and architected power systems.",
    highlight: "Real engineers, not just recruiters"
  },
  {
    id: 2,
    title: "Deep Technical Vetting",
    icon: "Shield",
    description: "Our screening process goes beyond resume keywords. We conduct technical assessments that evaluate architectural thinking, problem-solving approaches, and hands-on expertise.",
    highlight: "Engineer-to-engineer evaluation"
  },
  {
    id: 3,
    title: "Niche Expertise Access",
    icon: "Target",
    description: "Need someone with experience in multi-patterning lithography or distributed training of 100B+ parameter models? Our network includes rare specialists others can't identify.",
    highlight: "Find the unfindable talent"
  },
  {
    id: 4,
    title: "Speed Without Compromise",
    icon: "Rocket",
    description: "Technical depth doesn't mean slow. Our engineering background allows us to quickly identify qualified candidates while maintaining rigorous standards.",
    highlight: "3x faster than traditional executive search"
  }
];

// Form submission mock handler
export const mockSubmitContact = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock Contact Form Submission:", formData);
      resolve({
        success: true,
        message: "Thank you for contacting TAG. We'll respond within 24 hours."
      });
    }, 1500);
  });
};

export const mockSubmitResume = async (resumeData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock Resume Submission:", resumeData);
      resolve({
        success: true,
        message: "Resume received! Our team will review it and reach out if there's a match."
      });
    }, 2000);
  });
};
